import Swal from 'sweetalert2';
import { AuthContextType } from '../../auth/AuthContext';
import { AccountClass } from '../../classes/account/accountClass';
import { GlobalFormats } from '../../classes/main/globalFormatClass';
import { SwalPropertiesClass } from '../../classes/main/swalPropertiesClass';
import { UserService } from '../../services/users/UserService';
import { getError, getResponse, isUndNullEmpNew, setDateTimeFormatGlobal, settings } from '../UtilsHelper';

const { colors, html, labels, messages, sweetAlert2 } = settings

//#region methods
export const getUserById = async ({
    id = '',
    auth = AuthContextType,
    subMethod = '',
} = {}) => {
    const currentMethod = 'getUserById';
    let response = getResponse({ type: 0 });
    try {
        //#region methods
        response = await UserService?.getById({
            id: id,
            token: auth?.account?.tokenVzLaML?.token,
            subMethod: currentMethod,
        })
        if (!response?.isSuccess || response?.isWarning) return response;
        //#endregion methods
    } catch (ex) {
        response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
    }
    return response;
}

export const getUserAccountEnableDisable = async ({
    id = '',
    rowIndex = 0,
    dtId = '',
    $ = {},
    auth = AuthContextType,
    languageObj = GlobalFormats?.getClass(),
    setDataDtRow = ({
        user = AccountClass?.getClass(),
        languageObj = GlobalFormats?.getClass(),
        subMethod = ''
    }) => { },
    subMethod = ''
}) => {
    const currentMethod = 'getUserAccountEnableDisable';
    let response = getResponse({ type: 0 });
    try {
        //#region variables
        let user_ = AccountClass?.getClass();
        //#endregion variables

        //#region user get
        response = await getUserById({
            id: id,
            auth: auth,
            subMethod: currentMethod,
        });
        if (!response?.isSuccess || response?.isWarning) return response;

        user_ = response?.result?.account || {};
        //#endregion user get

        //#region userAccountEnableDisable
        response = await userAccountEnableDisable({
            user: user_,
            dtUsers: $(`#${dtId}`)?.DataTable(),
            rowIndex: rowIndex,
            auth: auth,
            languageObj: languageObj,
            setDataDtRow: setDataDtRow,
            subMethod: currentMethod,
        });
        if (!response?.isSuccess || response?.isWarning) return response;

        //#endregion userAccountEnableDisable
    } catch (ex) {
        response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
    }
    return response;
}

export const userAccountEnableDisable = async ({
    user = AccountClass?.getClass(),
    dtUsers = {},
    rowIndex = 0,
    auth = AuthContextType,
    languageObj = GlobalFormats?.getClass(),
    setDataDtRow = ({
        user = AccountClass?.getClass(),
        languageObj = GlobalFormats?.getClass(),
        subMethod = ''
    }) => { },
    subMethod = '',
}) => {
    const currentMethod = 'userAccountEnableDisable';
    let response = getResponse({ type: 0 });
    try {
        //#region variables
        let propertyObj = {
            input: {},
            remark: '',
        };
        let isConfirmed_ = true;
        let isDenied_ = false;
        let msgText_ = '';
        let swalProperties = SwalPropertiesClass?.getClass();
        //#endregion variables

        //#region show message
        //#region define message
        response = getUserMessage({
            msgText: '',
            firstName: user?.firstName,
            lastName: user?.lastName,
            email: user?.email,
            languageId: languageObj?.id,
            subMethod: currentMethod
        });

        if (!response?.isSuccess || response?.isWarning) return response

        msgText_ = response?.result || '';
        //#endregion define message

        if (!isUndNullEmpNew({ data: user?.isDisabled, subMethod: currentMethod, })?.result && user?.isDisabled) {
            const msgTextObj = {
                one: messages?.doYouWantToEnableTheAccountSeeTheAddedCommentOrCancel?.[languageObj?.id],
            };
            swalProperties = {
                icon: sweetAlert2?.icons?.info,
                title: labels?.information?.[languageObj?.id],
                html: `${msgTextObj?.one}`,
                timer: null,
                backdrop: true,
                confirmButtonColor: colors?.warningColorExp,
                confirmButtonText: labels?.enable?.[languageObj?.id],
                showCancelButton: true, //!Swal.isLoading(), //true,
                cancelButtonColor: colors?.successColorExp,
                cancelButtonText: labels?.cancel?.[languageObj?.id],
                showDenyButton: true,
                denyButtonText: labels?.comment?.[languageObj?.id],
                denyButtonColor: colors?.infoColorExp,
                customClass: {
                    popup: html?.popup,
                    confirmButton: html?.buttons?.primary,
                    cancelButton: html?.buttons?.secondary,
                    denyButton: html?.buttons?.secondary
                },
                didOpen: () => {
                    Swal.hideLoading();
                },
            };

            const { isConfirmed, isDenied } = await Swal?.fire({ ...swalProperties });

            isConfirmed_ = isConfirmed;
            isDenied_ = isDenied;
        }

        //#region remark
        if (isDenied_) {
            //#region get user (modified)
            response = await UserService?.getById({
                id: user?.isDisabledUserId,
                token: auth?.account?.tokenVzLaML?.token,
                subMethod: currentMethod
            });
            if (!response?.isSuccess || response?.isWarning) return response
            const userModified = response?.result?.account || {}
            //#endregion get user (modified)

            msgText_ = getUserMessageDisableDelete({
                msgText: '',
                firstName: user?.firstName,
                lastName: user?.lastName,
                email: user?.email,
                dateTime: user?.isDisabledDate,
                remark: user?.isDisabledRemark,
                userModified: userModified,
                languageObj: languageObj,
                subMethod: currentMethod,
            })?.result;

            swalProperties = {
                icon: sweetAlert2?.icons?.info,
                title: labels?.remark?.[languageObj?.id],
                html: msgText_,
                timer: null,
                backdrop: true,
                confirmButtonColor: colors?.successColorExp,
                confirmButtonText: labels?.close?.[languageObj?.id],
                customClass: {
                    popup: html?.popup,
                    confirmButton: html?.buttons?.primary,
                    cancelButton: html?.buttons?.secondary,
                },
                didOpen: () => {
                    Swal.hideLoading();
                },
            };

            Swal?.fire({ ...swalProperties });
        }
        //#endregion remark

        //#region user update (remark)
        if (isConfirmed_) {
            const msgTextObj = {
                one: isUndNullEmpNew({ data: user?.isDisabled, subMethod: currentMethod, })?.result || !user?.isDisabled ?
                    `${messages?.doYouWantToDisableTheAccount?.[languageObj?.id]}<br/><br/>` :
                    `${messages?.doYouWantToEnableTheAccount?.[languageObj?.id]}<br/><br/>`,
                two: msgText_,
                three: ``,
            };

            //#region input / remark set
            propertyObj = {
                input: {},
                remark: '',
            };

            if (isUndNullEmpNew({ data: user?.isDisabled, subMethod: currentMethod, })?.result || !user?.isDisabled) {
                propertyObj.input = {
                    input: 'textarea',
                    inputPlaceholder: labels?.enterRemark?.[languageObj?.id],
                    inputValidator: (value) => {
                        if (!value) {
                            return messages?.youMustAddComment?.[languageObj?.id];
                        }
                        propertyObj.remark = value;
                    },
                };
            }
            //#endregion input / remark set

            swalProperties = {
                icon: sweetAlert2?.icons?.warning,
                title: labels?.warning?.[languageObj?.id],
                html: `${msgTextObj?.one}${msgTextObj?.two}${msgTextObj?.three}`,
                timer: null,
                ...propertyObj.input,
                backdrop: true,
                confirmButtonColor: colors?.warningColorExp,
                confirmButtonText: labels?.yes?.[languageObj?.id],
                showCancelButton: true, //!Swal.isLoading(), //true,
                cancelButtonColor: colors?.successColorExp,
                cancelButtonText: labels?.no?.[languageObj?.id],
                showLoaderOnConfirm: true,
                customClass: {
                    popup: html?.popup,
                    confirmButton: html?.buttons?.primary,
                    cancelButton: html?.buttons?.secondary,
                },
                didOpen: () => {
                    Swal.hideLoading();
                },
                allowOutsideClick: () => !Swal.isLoading(),
                preConfirm: async () => {
                    let preConfirmResponse = getResponse({ type: 0 });
                    try {
                        Swal.getCancelButton().hidden = true;
                        Swal?.update({
                            icon: sweetAlert2?.icons?.info,
                            title: `${messages?.processing?.[languageObj?.id]}`,
                            html: `${msgTextObj?.two}`,
                            showConfirmButton: false,
                        });

                        //#region user update
                        user = {
                            ...user,
                            isDisabled: isUndNullEmpNew({ data: user?.isDisabled, subMethod: currentMethod, })?.result || !user?.isDisabled ? true : false,
                            isDisabledDate: new Date()?.toISOString(),
                            isDisabledUserId: auth?.account?.uid,
                            isDisabledRemark: propertyObj?.remark,
                            // add others properties
                            isPartialUpdate: true,
                            languageId: languageObj?.id,
                        };

                        preConfirmResponse = await UserService?.update({
                            id: user?.id,
                            data: user,
                            token: auth?.account?.tokenVzLaML?.token,
                            subMethod: currentMethod
                        });
                        if (!preConfirmResponse?.isSuccess || preConfirmResponse?.isWarning) return preConfirmResponse;

                        user = preConfirmResponse?.result?.accountML || {}
                        //#endregion user update

                        //#region update row data table
                        preConfirmResponse = setDataDtRow({
                            user: user,
                            languageObj: languageObj,
                            subMethod: currentMethod
                        });
                        if (!preConfirmResponse?.isSuccess || preConfirmResponse?.isWarning) return preConfirmResponse;

                        const dtRow = preConfirmResponse?.result || [];

                        dtUsers?.row(rowIndex)?.data(dtRow)?.draw(true);
                        //#endregion update row data table

                        preConfirmResponse.msgText = `${messages?.processCompletedSuccessfully?.[languageObj?.id]}.`;
                    } catch (ex) {
                        preConfirmResponse = getError({ ex: ex, response: preConfirmResponse, currentMethod_: currentMethod, subMethod_: subMethod });
                    }
                    return preConfirmResponse;
                }
            };

            const swalResult = await Swal.fire({ ...swalProperties });
            if (swalResult?.isConfirmed && swalResult?.value) {
                response = swalResult?.value;
            } else if (swalResult?.isDismissed) {
                response = getResponse({ type: 0 });
            }
        }
        //#endregion user update (remark)
        //#endregion show message 
    } catch (ex) {
        response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
    }
    return response;
}

export const getUserAccountDelete = async ({
    id = '',
    rowIndex = '',
    dtId = '',
    $ = {},
    auth = AuthContextType,
    languageObj = GlobalFormats?.getClass(),
    setDataDtRow = ({
        user = AccountClass?.getClass(),
        languageObj = GlobalFormats?.getClass(),
        subMethod = ''
    }) => { },
    subMethod = ''
}) => {
    const currentMethod = 'getUserAccountDelete';
    let response = getResponse({ type: 0 });
    try {
        //#region variables
        let user_ = AccountClass?.getClass();
        //#endregion variables

        //#region get user
        response = await getUserById({
            id: id,
            auth: auth,
            subMethod: currentMethod,
        });
        if (!response?.isSuccess || response?.isWarning) return response;

        user_ = response?.result?.account || {};
        //#endregion get user

        //#region userAccountDelete
        response = await userAccountDelete({
            user: user_,
            dtUsers: $(`#${dtId}`)?.DataTable(),
            rowIndex: rowIndex,
            auth: auth,
            setDataDtRow: setDataDtRow,
            languageObj: languageObj,
            subMethod: currentMethod,
        });

        if (!response?.isSuccess || response?.isWarning) return response;
        //#endregion userAccountDelete
    } catch (ex) {
        response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
    }
    return response;
}

export const userAccountDelete = async ({
    user = AccountClass?.getClass(),
    dtUsers = {},
    rowIndex = 0,
    auth = AuthContextType,
    setDataDtRow = ({
        user = AccountClass?.getClass(),
        languageObj = GlobalFormats?.getClass(),
        subMethod = ''
    }) => { },
    languageObj = GlobalFormats?.getClass(),
    subMethod = '',
}) => {
    const currentMethod = 'userAccountDelete';
    let response = getResponse({ type: 0 });
    try {
        //#region variables
        let propertyObj = {
            input: {},
            remark: '',
        };
        let isConfirmed_ = true;
        let isDenied_ = false;
        let msgText_ = '';
        let swalProperties = SwalPropertiesClass?.getClass();
        //#endregion variables

        //#region show message
        //#region define message
        response = getUserMessage({
            msgText: '',
            firstName: user?.firstName,
            lastName: user?.lastName,
            email: user?.email,
            languageId: languageObj?.id,
            subMethod: currentMethod
        });
        if (!response?.isSuccess || response?.isWarning) return response

        msgText_ = response?.result || '';
        //#endregion define message

        if (!isUndNullEmpNew({ data: user?.isDeleted, subMethod: currentMethod, })?.result && user?.isDeleted) {
            const msgTextObj = {
                one: messages?.doYouWantToRestoreTheRecordViewTheAddedCommentOrCancel?.[languageObj?.id],
            };
            swalProperties = {
                icon: sweetAlert2?.icons?.info,
                title: labels?.information?.[languageObj?.id],
                html: `${msgTextObj?.one}`,
                timer: null,
                backdrop: true,
                confirmButtonColor: colors?.warningColorExp,
                confirmButtonText: labels?.restore?.[languageObj?.id],
                showCancelButton: true, //!Swal.isLoading(), //true,
                cancelButtonColor: colors?.successColorExp,
                cancelButtonText: labels?.cancel?.[languageObj?.id],
                showDenyButton: true,
                denyButtonText: labels?.comment?.[languageObj?.id],
                denyButtonColor: colors?.infoColorExp,
                customClass: {
                    popup: html?.popup,
                    confirmButton: html?.buttons?.primary,
                    cancelButton: html?.buttons?.secondary,
                    denyButton: html?.buttons?.secondary
                },
                didOpen: () => {
                    Swal.hideLoading();
                },
            };

            const { isConfirmed, isDenied } = await Swal?.fire({ ...swalProperties });

            isConfirmed_ = isConfirmed;
            isDenied_ = isDenied;
        }

        //#region remark
        if (isDenied_) {
            //#region get user (modified)
            response = await getUserById({
                id: user?.isDeletedUserId,
                auth: auth,
                subMethod: currentMethod
            });
            if (!response?.isSuccess || response?.isWarning) return response;

            const userModified = response?.result?.account || {};
            //#endregion get user (modified)

            msgText_ = getUserMessageDisableDelete({
                msgText: '',
                firstName: user?.firstName,
                lastName: user?.lastName,
                email: user?.email,
                dateTime: user?.isDeletedDate,
                remark: user?.isDeletedRemark,
                userModified: userModified,
                languageObj: languageObj,
                subMethod: currentMethod,
            })?.result;

            swalProperties = {
                icon: sweetAlert2?.icons?.info,
                title: labels?.remark?.[languageObj?.id],
                html: msgText_,
                timer: null,
                backdrop: true,
                confirmButtonColor: colors?.successColorExp,
                confirmButtonText: labels?.close?.[languageObj?.id],
                customClass: {
                    popup: html?.popup,
                    confirmButton: html?.buttons?.primary,
                },
                didOpen: () => {
                    Swal.hideLoading();
                },
            };

            Swal?.fire({ ...swalProperties });
        }
        //#endregion remark

        //#region user update (remark)
        if (isConfirmed_) {
            const msgTextObj = {
                one: isUndNullEmpNew({ data: user?.isDeleted, subMethod: currentMethod, })?.result || !user?.isDeleted ?
                    `${messages?.areYouSureDeleteThis?.[languageObj?.id]}<br/><br/>` :
                    `${messages?.doYouWantToRestoreDeletedRegistry?.[languageObj?.id]}<br/><br/>`,

                two: msgText_,
                three: ``,
            };

            //#region input / remark set
            propertyObj = {
                input: {},
                remark: '',
            };

            if (isUndNullEmpNew({ data: user?.isDeleted, subMethod: currentMethod, })?.result || !user?.isDeleted) {
                propertyObj.input = {
                    input: 'textarea',
                    inputPlaceholder: labels?.enterRemark?.[languageObj?.id],
                    inputValidator: (value) => {
                        if (!value) {
                            return messages?.youMustAddComment?.[languageObj?.id];
                        }
                        propertyObj.remark = value;
                    },
                };
            }
            //#endregion input / remark set

            swalProperties = {
                icon: sweetAlert2?.icons?.warning,
                title: labels?.warning?.[languageObj?.id],
                html: `${msgTextObj?.one}${msgTextObj?.two}${msgTextObj?.three}`,
                timer: null,
                ...propertyObj.input,
                backdrop: true,
                confirmButtonColor: colors?.warningColorExp,
                confirmButtonText: labels?.yes?.[languageObj?.id],
                showCancelButton: true, //!Swal.isLoading(), //true,
                cancelButtonColor: colors?.successColorExp,
                cancelButtonText: labels?.no?.[languageObj?.id],
                showLoaderOnConfirm: true,
                customClass: {
                    popup: html?.popup,
                    confirmButton: html?.buttons?.primary,
                    cancelButton: html?.buttons?.secondary,
                },
                didOpen: () => {
                    Swal.hideLoading();
                },
                allowOutsideClick: () => !Swal.isLoading(),
                preConfirm: async () => {
                    let preConfirmResponse = getResponse({ type: 0 });
                    try {
                        Swal.getCancelButton().hidden = true;
                        Swal?.update({
                            icon: sweetAlert2?.icons?.info,
                            title: `${messages?.processing?.[languageObj?.id]}`,
                            html: `${msgTextObj?.two}`,
                            showConfirmButton: false,
                        });

                        //#region user update
                        user = {
                            ...user,
                            isDeleted: isUndNullEmpNew({ data: user?.isDeleted, subMethod: currentMethod, })?.result || !user?.isDeleted ? true : false,
                            isDeletedDate: new Date()?.toISOString(),
                            isDeletedUserId: auth?.account?.uid,
                            isDeletedRemark: propertyObj?.remark,
                            // add others properties
                            isPartialUpdate: true,
                            languageId: languageObj?.id,
                        };

                        preConfirmResponse = await UserService?.update({
                            id: user?.id,
                            data: user,
                            token: auth?.account?.tokenVzLaML?.token,
                            subMethod: currentMethod
                        });
                        if (!preConfirmResponse?.isSuccess || preConfirmResponse?.isWarning) return preConfirmResponse;

                        user = preConfirmResponse?.result?.accountML || {}
                        //#endregion user update

                        //#region update row data table
                        preConfirmResponse = setDataDtRow({
                            user: user,
                            languageObj: languageObj,
                            subMethod: currentMethod
                        });
                        if (!preConfirmResponse?.isSuccess || preConfirmResponse?.isWarning) return preConfirmResponse;

                        const dtRow = preConfirmResponse?.result || [];

                        dtUsers?.row(rowIndex)?.data(dtRow)?.draw(true);
                        //#endregion update row data table

                        preConfirmResponse.msgText = `${messages?.processCompletedSuccessfully?.[languageObj?.id]}.`;
                    } catch (ex) {
                        preConfirmResponse = getError({ ex: ex, response: preConfirmResponse, currentMethod_: currentMethod, subMethod_: subMethod });
                    }
                    return preConfirmResponse;
                },
            };

            const swalResult = await Swal.fire({ ...swalProperties });
            if (swalResult?.isConfirmed && swalResult?.value) {
                response = swalResult?.value;
            } else if (swalResult?.isDismissed) {
                response = getResponse({ type: 0 });
            }
        }
        //#endregion user update (remark)
        //#endregion show message
    } catch (ex) {
        response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
    }
    return response;
}
//#endregion methods

//#region messages (get)
const getUserMessage = ({
    msgText = '',
    firstName = '',
    lastName = '',
    email = '',
    languageId = 'en',
    subMethod = '',
}) => {
    const currentMethod = 'getUserMessage';
    let response = getResponse({ type: 0 });
    try {
        response.result = `<div class='table-responsive' style='font-size:14px'>`;
        if (!isUndNullEmpNew({ data: msgText, subMethod: currentMethod, })?.result) {
            response.result += `   <div>${msgText}</div>`;
            response.result += `  <br/>`;
        }
        response.result += `    <table class='table table-sm'>`;
        response.result += `       <col width='20px'/>`;
        response.result += `       <col width='80px'/>`;
        response.result += `       <tbody class='text-left'>`;
        response.result += `           <tr>`;
        response.result += `               <td>${labels?.user?.[languageId]}:</td>`;
        response.result += `               <td><b>${firstName}, ${lastName}</b></td>`;
        response.result += `           </tr>`;
        response.result += `           <tr>`;
        response.result += `               <td>${labels?.email?.[languageId]}:</td>`;
        response.result += `               <td><b>${email}</b></td>`;
        response.result += `           </tr>`;
        response.result += `       </tbody>`;
        response.result += `   </table>`;
        response.result += `</div>`;
    } catch (ex) {
        response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
    }
    return response;
}

const getUserMessageDisableDelete = ({
    msgText = '',
    firstName = '',
    lastName = '',
    email = '',
    dateTime = new Date()?.toISOString(),
    remark = '',
    userModified = AccountClass?.getClass(),
    languageObj = GlobalFormats?.getClass(),
    subMethod = '',
}) => {
    const currentMethod = 'getUserMessageDisableDelete';
    let response = getResponse({ type: 0 });
    try {
        const dateTime_ = setDateTimeFormatGlobal({
            date: dateTime,
            type: languageObj?.format?.date?.f1,
            format: languageObj?.format?.time?.type,
            addTime: false,
            secondsShow: false,
            languageId: languageObj?.id,
            subMethod: currentMethod,
        })?.result;

        response.result = `<div class='table-responsive' style='font-size:14px'>`;
        if (!isUndNullEmpNew({ data: msgText, subMethod: currentMethod, })?.result) {
            response.result += `   <div>${msgText}</div>`;
            response.result += `  <br/>`;
        }
        response.result += `    <table class='table table-sm'>`;
        response.result += `       <col width='20px'/>`;
        response.result += `       <col width='80px'/>`;
        response.result += `       <tbody class='text-left'>`;
        response.result += `           <tr>`;
        response.result += `               <td>${labels?.user?.[languageObj?.id]}:</td>`;
        response.result += `               <td><b>${firstName}, ${lastName}</b></td>`;
        response.result += `           </tr>`;
        response.result += `           <tr>`;
        response.result += `               <td>${labels?.email?.[languageObj?.id]}:</td>`;
        response.result += `               <td><b>${email}</b></td>`;
        response.result += `           </tr>`;
        response.result += `           <tr>`;
        response.result += `               <td colspan='2'><hr style='border: none; border-top: 1px dotted'/></td>`;
        response.result += `           </tr>`;
        response.result += `           <tr>`;
        response.result += `               <td colspan='2'><b>${labels?.modifiedBy?.[languageObj?.id]}</b></td>`;
        response.result += `           </tr>`;
        if (!isUndNullEmpNew({ data: userModified?.firstName, subMethod: currentMethod })?.result ||
            !isUndNullEmpNew({ data: userModified?.lastName, subMethod: currentMethod })?.result ||
            !isUndNullEmpNew({ data: userModified?.email, subMethod: currentMethod })?.result) {
            response.result += `           <tr>`;
            response.result += `               <td>${labels?.user?.[languageObj?.id]}:</td>`;
            response.result += `               <td><b>${userModified?.firstName || ''} ${userModified?.lastName || ''}</b></td>`;
            response.result += `           </tr>`;
            response.result += `           <tr>`;
            response.result += `               <td>${labels?.email?.[languageObj?.id]}:</td>`;
            response.result += `               <td><b>${userModified?.email || ''}</b></td>`;
            response.result += `           </tr>`;
        }
        response.result += `           <tr>`;
        response.result += `               <td>${labels?.date?.[languageObj?.id]}:</td>`;
        response.result += `               <td><b>${dateTime_}</b></td>`;
        response.result += `           </tr>`;
        response.result += `           <tr>`;
        response.result += `               <td>${labels?.comment?.[languageObj?.id]}:</td>`;
        response.result += `               <td><b>${remark || ''}</b></td>`;
        response.result += `           </tr>`;
        response.result += `       </tbody>`;
        response.result += `   </table>`;
        response.result += `</div>`;
    } catch (ex) {
        response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
    }
    return response;
}
//#endregion messages (get)